import React, { useState } from 'react'
import t from '../../service/translate.service'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { useMsal } from '@azure/msal-react'
import LoadingPageOverlay from '../LoadingPageOverlay'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import PrimaryTitle from '../PrimaryTitle'
import './index.css'
const ContractSign = (props) => {
  const { instance } = useMsal()
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [users, setUsers] = useState([])

  useEffect(() => {
    ;(async () => {
      setTimeout(async () => {
        await props.userStore.loadUser()
        setLoading(false)
      }, 2000)
    })()
  }, [])

  useEffect(() => {
    if (props?.userStore?.user) {
      const scriveSignId = props?.userStore?.user?.scriveSignId || ''
      const user =
        props?.userStore?.user?.contractAssignedData?.tenantsDetails?.find(
          (tenant) => tenant?.scriveLink?.includes(scriveSignId)
        )
      if (user) {
        const sameUsers =
          props?.userStore?.user?.contractAssignedData?.tenantsDetails?.filter(
            (tenant) =>
              tenant?.email?.toLowerCase() === user?.email?.toLowerCase()
          )
        setUsers(sameUsers)
      } else {
        setUsers([])
      }
    }
  }, [props?.userStore?.user])

  if (loading) {
    return <LoadingPageOverlay />
  }

  return (
    <div
      className={`contract-sign-page ${props?.userStore?.haveContractToSign && props?.userStore?.showContractSignModal ? 'thank-you-overlay' : ''}`}
      style={{ left: 0 }}
      role="dialog"
      aria-labelledby="thank-you-title"
      aria-describedby="thank-you-description"
    >
      <div className="wrapper">
        <PrimaryTitle title={t.CONTRACT_SIGN} />
        <div
          role="alert"
          aria-live="assertive"
          id="thank-you-description"
          className="description"
        >
          {props?.userStore?.user?.contractAssignedData?.tenantsDetails
            ?.length > 1
            ? t.CONTRACT_SIGN_MULTI_THANK_YOU_TEXT
            : t.CONTRACT_SIGN_THANK_YOU_TEXT}
        </div>
        {users?.map((user, index) => {
          return (
            <Link
              key={index}
              style={{ marginTop: '10px' }}
              to={user?.scriveLink || ''}
              className="button primary"
              target="_blank"
              aria-label={t.CONTRACT_SIGN_CONTINUE}
            >
              {users?.length === 1
                ? t.CONTRACT_SIGN_CONTINUE
                : `${user?.firstName} ${user?.lastName}`}
            </Link>
          )
        })}
        {props?.userStore?.haveContractToSign && props?.userStore?.showContractSignModal && (
          <button
            style={{ marginTop: '10px' }}
            className="button tertiary"
            type='button'
            onClick={() => {
              localStorage.setItem('hide_contract_assign_modal', 'true')
              props?.userStore?.setShowContractSignModal()
              navigate('/')
            }}
            aria-label={t.CONTRACT_SIGN_BACK_TO_HOME}
          >
            {t.CONTRACT_SIGN_BACK_TO_HOME}
          </button>
        )}
      </div>
    </div>
  )
}
ContractSign.propTypes = {
  userStore: PropTypes.object.isRequired
}
export default inject('userStore')(observer(ContractSign))
